<template>
  <div class="opple-ability-ui-com-imgEnum">
    <div
      slot="reference"
      class="opple-ability-ui-com-imgEnum_preview"
    >
      <div
        class="opple-ability-ui-com-imgEnum_imgSelect"
      >
        <div
          v-for="(item, index) in imgList"
          :key="index"
          :class="{active: !!item.isSelect}"
          class="opple-ability-ui-com-imgEnum_imgSelect_container"
          @click="() => handlerActive(index)"
        >
          <div
            class="opple-ability-ui-com-imgEnum_imgSelect_checkbox"
          />
          <div
            class="opple-ability-ui-com-imgEnum_imgSelect_img"
          >
            <div class="opple-ability-ui-com-imgEnum_imgSelect_img-popup">
              <img
                :src="item.src"
                alt=""
              >
            </div>
            <img
              class="opple-ability-ui-com-imgEnum_imgSelect_img-real"
              :src="item.src"
              alt=""
            >
          </div>
        </div>
      </div>
    </div> 
    <!-- <el-popover
      placement="right"
      width="192"
      trigger="hover"
    >
      <div class="opple-ability-ui-com-imgEnum_bigimg">
        <img :src="perviewSrc">
      </div>
      <div
        slot="reference"
        class="opple-ability-ui-com-imgEnum_preview"
      >
        <div
          class="opple-ability-ui-com-imgEnum_imgSelect"
        >
          <div
            v-for="(item, index) in imgList"
            :key="index"
            :class="{active: !!item.isSelect}"
            class="opple-ability-ui-com-imgEnum_imgSelect_container"
            @click="() => handlerActive(index)"
          >
            <div
              class="opple-ability-ui-com-imgEnum_imgSelect_checkbox"
            />
            <div
              class="opple-ability-ui-com-imgEnum_imgSelect_img"
            >
              <img
                :src="item.src"
                alt=""
              >
            </div>
          </div>
        </div>
      </div> 
    </el-popover> -->
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    ui: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      perviewSrc: '',
      imgList: [],
    }
  },

  computed: {
   
  },

  mounted() {
    this.setImgPrivew();
    this.setImgList();
  },

  methods: {
    setImgPrivew() {
      // console.log('this.item.DefaultValue', this.item.DefaultValue);
      this.perviewSrc = this.transStrToSrc(this.item.DefaultValue);
      console.log('图片重新渲染', this.item);
    },

    setImgList() {
      const EnumValue = this.item.EnumValue || [];

      this.imgList = EnumValue.map((item, index) => {
        const src = this.transStrToSrc(item.Name);
        // console.log('srcsrc', src, this.perviewSrc);
        return {
          src,
          value: item.Value,
          Name: item.Name,
          isSelect: src === this.perviewSrc
        }
      })
    },

    transStrToSrc(str) {
      try {
        return JSON.parse(str).pic || '';
      } catch (e) {
        return ''
      }
    },

    handlerActive(i) {
      let perviewSrc = '';

      this.imgList = this.imgList.map((item, index) => {
        const isSelect = index === i;

        if (isSelect) perviewSrc = item.src;

        return {
          ...item,
          isSelect,
        }
      });

      this.perviewSrc = perviewSrc;
    },

    getData() {
      const Value = this.imgList.find(item => item.isSelect).Name;
      return {
        Key: this.item.KeyId,
        Values: [Value]
      }
    }
  },
};
</script>

<style lang="scss" scoped>

.opple-ability-ui-com-info {
  width: 300px;
  margin-right: 0px !important;
}

.opple-ability-ui-com-imgEnum {

  &_imgSelect {
    width: 320px;
    // overflow: hidden;
   
    &_container {
      display: flex;
      // width: 95px;
      float: left;
      // margin-left: 10px;
      justify-content: space-between;
      align-items: center;
      &:not(:last-child) {
        margin-right: 30px;
      }
      
      &.active {
        .opple-ability-ui-com-imgEnum_imgSelect_checkbox::after {
          position: absolute;
          content: '';
          width: 6px;
          height: 6px;
          left: 2px;
          top: 2px;
          background-color: #2589FF;
          border-radius: 50%;
        }
      }
    }

    &_checkbox {
      position: relative;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      border: 1px solid #2589FF;
      margin-right: 6px;
    }
    &_img {
      position: relative;
      // width: 73px;
      height: 29px;
      object-fit: contain;
      // overflow: hidden;
  
      &:not(:last-child) {
        margin-right: 10px;
      }

      &-real {
        // width: 73px;
        height: 29px;
        object-fit: contain;
      }

      &:hover {
        .opple-ability-ui-com-imgEnum_imgSelect_img-popup {
          display: block;
        }
      }
      
      &-popup {
        position: absolute;
        display: none;
        padding: 6px;
        width: 128px;
        height: 50px;
        background-color: #fff;
        top: 35px;
        left: -31px;
        z-index: 5;
        box-shadow: 10px 10px 10px rgba(0, 0, 0, .2);
        border-radius: 4px;
        img {
          width: 128px;
          height: 50px;
          margin: 0 auto;
          object-fit: contain;
        }
      }
    }
  }
}
</style>